<template>
  <div>
    <table class="w-100 table table-bordered-layout table-sm">
      <thead>
        <tr>
          <th v-if="checkBoxStatus" />
          <th>#</th>
          <th>
            {{ t('Origin') }}
          </th>
          <th>
            {{ t('Description') }}
          </th>
          <th>
            {{ t('Gtip Code') }}
          </th>
          <th>
            {{ t('Quantity') }}
          </th>
          <th>
            {{ t('Unit Price') }}
          </th>
        </tr>
      </thead>
      <tbody class="font-small-3">
        <tr v-for="(item, index) in items" :key="index">
          <td v-if="checkBoxStatus">
            <b-form-checkbox class="mr-0" @change="returnItems($event, item, index)" />
          </td>
          <td class="font-weight-bolder">
            {{ index + 1 }}
          </td>
          <td>
            <b-badge variant="dark">
              {{ item.origin }}
            </b-badge>
          </td>
          <td class="font-weight-bolder">
            <div>{{ item.description }}</div>
            <div
              v-if="
                item.merchant_product_id || item.manufacturer_product_id || item.standard_product_id
              "
              class="mt-25 d-flex flex-wrap"
              style="gap: 4px"
            >
              <b-badge v-if="item.merchant_product_id" variant="light-primary" class="font-small-1">
                M-PID: {{ item.merchant_product_id }}
              </b-badge>
              <b-badge
                v-if="item.manufacturer_product_id"
                variant="light-info"
                class="font-small-1"
              >
                NS-PID: {{ item.manufacturer_product_id }}
              </b-badge>
              <b-badge
                v-if="item.standard_product_id"
                variant="light-secondary"
                class="font-small-1"
              >
                S-PID: {{ item.standard_product_id }}
              </b-badge>
            </div>
          </td>
          <td>
            {{ item.gtip }}
          </td>
          <td>
            {{ item.quantity }}
          </td>
          <td>{{ item.unit_price }} ({{ item.currency }})</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BBadge, BFormCheckbox } from 'bootstrap-vue';

export default {
  components: {
    BBadge,
    BFormCheckbox
  },
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    checkBoxStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      returnArray: []
    };
  },

  methods: {
    returnItems(event, item, index) {
      if (event && item) {
        this.returnArray.push(item);
      } else {
        this.returnArray.splice(index, 1);
      }

      this.$store.commit('app/SET_RETURN_ITEMS', this.returnArray);
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
